import RemoveCircleIcon from "@mui/icons-material/RemoveCircle"
import {
  Box,
  Chip,
  Stack,
  Tooltip,
  Typography,
  chipClasses,
  styled,
  useTheme,
} from "@mui/material"
import type { ReactNode } from "react"
import { Check, MinusCircle } from "react-feather"

const BaseListChipLabel = ({
  startIcon,
  label,
}: { startIcon: ReactNode; label: string }) => {
  return (
    <Stack direction="row">
      <Box marginLeft="-2px" marginRight="2px" display="flex">
        {startIcon}
      </Box>
      {label}
    </Stack>
  )
}

const BaseListChip = styled(Chip)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.2, 0.6),
  textTransform: "uppercase",
  lineHeight: theme.typography.pxToRem(11),
  fontSize: theme.typography.pxToRem(9),
  fontWeight: 600,
  pointerEvents: "none",
  height: "unset",
  [`.${chipClasses.label}`]: {
    padding: 0,
    overflow: "visible",
  },
}))

export const ListUltraChip = styled(BaseListChip)(({ theme }) => ({
  color: theme.palette.common.electricBlue,
  borderColor: theme.palette.common.electricBlue,
}))
ListUltraChip.defaultProps = {
  variant: "outlined",
  size: "small",
  label: <BaseListChipLabel startIcon={<Check size={11} />} label="ULTRA" />,
}

export const ListNegativeSegmentationChip = styled(BaseListChip)(({ theme }) => ({
  color: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  opacity: 0.7,
}))
ListNegativeSegmentationChip.defaultProps = {
  variant: "outlined",
  size: "small",
  label: (
    <BaseListChipLabel
      startIcon={<MinusCircle size={11} />}
      label="Segmentation Négative"
    />
  ),
}

interface TablePharmacyNameProps {
  name: string
  negativeSegmentation?: boolean
}
export const TablePharmacyName = ({
  name,
  negativeSegmentation,
}: TablePharmacyNameProps) => {
  const { palette } = useTheme()
  const redColorLight = palette.negativeSegmentation.light
  const IconRedColor = palette.negativeSegmentation.dark4
  return (
    <>
      {negativeSegmentation ? (
        <Tooltip title="Segmentation négative">
          <Box display="flex" alignItems="center">
            <Box bgcolor={redColorLight}>
              <Typography fontSize="inherit" fontWeight="bold">
                {name}
              </Typography>
            </Box>
            <RemoveCircleIcon
              sx={{ color: IconRedColor, fontSize: 16, marginLeft: 0.5 }}
            />
          </Box>
        </Tooltip>
      ) : (
        <Typography fontSize="inherit" fontWeight="bold">
          {name}
        </Typography>
      )}
    </>
  )
}
